import { render, staticRenderFns } from "./CustomerCreationDialog.vue?vue&type=template&id=3f7c6210&scoped=true"
import script from "./CustomerCreationDialog.vue?vue&type=script&lang=js"
export * from "./CustomerCreationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7c6210",
  null
  
)

export default component.exports